import React, { useEffect, useState } from 'react'
import { deleteCookie } from '../hooks/user'
import { connect } from 'react-redux'
import { setUserActive, showPopup, resetBudget } from '../actions'
import { useNavigate } from "react-router-dom"
import { UserIcon } from '../utils/icons'
import './UserPage.scss'
import UserInfo from '../components/UserInfo'
import UserBudgets from '../components/UserBudgets'
import { scrollBodyTop } from '../hooks/scrollPosition'
import _ from 'lodash'
const UserPage = (props) => {
    const navigate = useNavigate();

    const { userActive } = props

    const [user, setUser] = useState(userActive)

    const handleClickCloseSession = () => {
        deleteCookie().then(res => {
            props.setUserActive({})
            props.showPopup({ active: true, message: 'Sesión cerrada', type: 'success' })
            props.resetBudget()
            navigate(-1)
        })
    };

    useEffect(() => {
        scrollBodyTop()
        if (_.isEmpty(userActive)) {
            navigate(-1)
        }
    }, [])

    return (
        <div className="user-page-container">
            <div className="header">
                <div className="name">
                    <p className="title">PERFIL</p>
                    <p className="data">{user.name}</p>
                </div>
                <div className="icon">
                    <UserIcon />
                </div>
                <div className="botones">
                    <button className="btn" onClick={handleClickCloseSession}>Cerrar sesión</button>
                </div>
            </div>
            <div className="user-info">
                <UserInfo userData={user} />
            </div>
            <div className="user-budgets">
                <UserBudgets userData={user} />
            </div>

        </div>
    )
}

const mapDispatchToProps = {
    setUserActive,
    resetBudget,
    showPopup
}

const mapStateToProps = state => state

export default connect(mapStateToProps, mapDispatchToProps)(UserPage)